import { useState } from "react";

function CsvUpload({fileSelected}) {
  const [file, setFile] = useState(null);



  const getFile= async (f) => {


    setFile(f);
    fileSelected(f);
  }
  const uploadFile = async () => {
    if (!file) return;

    const formData = new FormData();
    formData.append("csv", file);

    const response = await fetch("/api/upload.php", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();
    console.log(data);
  };

  return (
    <>
     <div className="max-w-md ">
  <h3 className="mb-2 text-xs font-semibold text-gray-800">
    Import pliku CSV
  </h3>

  <label className="flex cursor-pointer items-center justify-center rounded-sm border-1 border-dashed border-gray-300 bg-gray-50 px-4 py-4 text-gray-600 transition hover:border-primary-500 hover:bg-blue-50">
    <div className="text-center">
     {file ? (
    <p className=" text-sm text-gray-700">
      Wybrano: <span className="font-medium">{file.name}</span>
    </p>
  ):( 
    <div>
      <p className="font-medium text-sm">📁 Wybierz plik CSV</p>

  <p className="mt-1 text-xs text-gray-500">
        Kliknij, aby wybrać plik
      </p>
      </div>)}
      <input
        type="file"
        accept=".csv"
        className="hidden"
        onChange={(e) => getFile(e.target.files[0])}
      />
    </div>
  </label>

  

  <button
    onClick={uploadFile}
    disabled={!file}
    className="hidden mt-2 rounded-xs bg-primary-500 px-4 text-xs py-1.5 font-medium text-white transition hover:bg-primary-700 disabled:cursor-not-allowed disabled:bg-gray-300"
  >
    Wyślij plik
  </button>
</div>
    </>
  );
}

export default CsvUpload;